import { ApplicationRoutes } from '../../../app-routes-names'

export const AddonsRoutes = {
  summary: 'summary'
}

const { addons } = ApplicationRoutes

export const AddonsPaths = {
  summary: `/${addons}/${AddonsRoutes.summary}`
}
